import React from "react";
import image from "../assets/images/not_found.svg";

const NotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "80vh",
        justifyContent: "center",
      }}
    >
      <img src={image} alt="" />
    </div>
  );
};

export default NotFound;
